import React, { useEffect, useState } from "react";
import { Divider, Card, Skeleton } from 'antd';
import axios from "axios";
import { Link } from "react-router-dom";
import "../css/home.css";




const { Meta } = Card;

const Games = () => {

    let [dataGames, setDataGames] = useState([])
    let [loadingStatus, setLoadingStatus] = useState(true)

    useEffect (() => {

    
    let getData = async () =>{
    let resultGames = await axios.get('https://backendexample.sanbersy.com/api/data-game')
    setDataGames([...resultGames.data])
    setLoadingStatus(false)
}

    getData ()

}, [loadingStatus, setLoadingStatus])


    let SkeletonComponent = () => {
    return (<Card
    hoverable
    style={{ width : 240}}
    cover={<Skeleton.Image style={{width: 240}} />}>
<Skeleton/>
</Card>)
    }

    return (
        <div>
            <Divider style={{color: "white", fontSize: "45px", fontWeight: "bold", textAlign: "center", marginTop: "80px"}}> Games</Divider>
            <div style={{backgroundColor:"black", color:"white"}} className="container-home">
                
                {loadingStatus && <SkeletonComponent/>
                }

                {dataGames !== null && (
                <>
                {dataGames.map((res, index) => {
                    return (
            <Link key={index} to={`/game/${res.id}`}>
            <Card  
            key={index}
             hoverable
             style={{ width: 240, padding:"20px", xs:"480px", sm: "768px", md: "992px", lg:"1200px", xl:'1600px' }}
             cover={<img alt="Games" src={res.image_url} width={250} height={250} />}> 
           
            <Meta title={res.name} description={res.platform} />
        </Card> 
        </Link>

                    )
                })}
                </>
            )}
            
            
            </div>
        </div>
    )}

export default Games